import clsx from "clsx";

import { Tooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { getBackgroundColorClass } from "@features/product-analytics/metricsData";
import { formatting } from "@north-beam/nb-common";

export const CacPercentage = ({
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  return (
    <div
      className={clsx(
        "px-2 items-center flex h-full font-mono text-sm font-medium w-full",
      )}
    >
      <Tooltip
        noInfoCircle
        overlayClassName="bg-[#010715] rounded-lg p-4"
        className="w-full flex justify-end"
        content={
          <div className="text-white">
            <div className="text-[#F2F3F5] text-xs font-semibold uppercase">
              Relative CAC
            </div>
            <div className="h-[1px] bg-v2-primary my-2"></div>
            <div className="w-[400px] text-[#F2F3F5] text-sm font-normal mb-2">
              A score from 1 to 100 that represents how expensive it is to
              advertise this product compared to all other products. A higher
              score is better, indicating lower costs.
            </div>
            <div className="flex justify-between">
              <div className="text-[#F2F3F5] font-semibold text-sm">CAC:</div>
              <div className="text-[#F2F3F5] font-tt-commons-pro-mono text-sm font-normal">
                {formatting.formatCurrency(row.cac, {
                  code: user.currencies.currentCurrency,
                })}
              </div>
            </div>
            <div className="flex justify-between">
              <div className="text-[#F2F3F5] font-semibold text-sm">Spend:</div>
              <div className="text-[#F2F3F5] font-tt-commons-pro-mono text-sm font-normal">
                {formatting.formatCurrency(row.spend, {
                  code: user.currencies.currentCurrency,
                })}
              </div>
            </div>
            <div className="flex justify-between">
              <div className="text-[#F2F3F5] font-semibold text-sm">
                Transactions:
              </div>
              <div className="text-[#F2F3F5] font-tt-commons-pro-mono text-sm font-normal">
                {Math.trunc(row.txns)}
              </div>
            </div>
          </div>
        }
      >
        <div
          className={clsx(
            "text-right w-[19px] h-[17px] font-tt-commons-pro-mono text-xs font-normal rounded flex justify-center items-center",
            getBackgroundColorClass(row.cacPercentage),
          )}
        >
          {Math.trunc(row.cacPercentage)}
        </div>
      </Tooltip>
    </div>
  );
};
